<template>
  <PopupMessage
    v-if="showPopupMessage"
    :title="null"
    :message="'Are you tax exempt?'"
    :cancel-label="'No'"
    :confirm-label="isThinking ? '<div class=\'loading\' style=\'margin: 0 auto\'></div>' : 'Yes'"
    @close="onClose"
    @confirm="onConfirm"
    @cancel="onCancel"
  />
</template>

<script>
import PopupMessage from './PopupMessage.vue'

/**
 * The TaxExemptPopupMessage Component
 *
 * CU-LL-1126: Any click to close popup should set show_tax_exempt_popup = 'n'
 *
 * @displayName Are you tax exempt? Popup Message
 */
export default {
  name: 'TaxExemptPopupMessage',
  components: {
    PopupMessage
  },
  props: [],
  data () {
    return {
      showPopupMessage: false,
      isThinking: false
    }
  },
  computed: {
    /**
     * Returns customer object.
     *
     * @public
     */
    customer: function () {
      return this.$store.getters.customer
    },
    /**
     * Returns if customer is authenticated.
     *
     * @public
     */
    authenticated: function () {
      return this.$store.getters.isAuthenticated
    }
  },
  watch: {
    /**
     * Will watch when customer object changes to determine if PopupMessage should show.
     *
     * @public
     */
    customer: function () {
      // If disabled at page level, do not show
      if (window.popup_message_disabled !== true) {
        // Now we check if customer should see this and set accordingly
        if (this.customer) {
          if (this.customer.show_tax_exempt_popup === 'y') {
            this.showPopupMessage = true
          }
        }
      }
    }
  },
  mounted () {},
  methods: {
    /**
     * Gets called when user closes PopupMessage.
     *
     * @public
     */
    onClose: function () {
      // Message was closed, update show_tax_exempt_popup so we do not show popup again
      this.$store.dispatch('updateCustomerShowTaxExemptPopup', {
        show_tax_exempt_popup: 'n'
      })
    },
    /**
     * Gets called when user cancels PopupMessage.
     *
     * @public
     */
    onCancel: function () {
      // Message 'No' clicked, update show_tax_exempt_popup so we do not show popup again
      this.$store.dispatch('updateCustomerShowTaxExemptPopup', {
        show_tax_exempt_popup: 'n'
      })
    },
    /**
     * Gets called when user confirms they are tax-exempt.
     *
     * @public
     */
    onConfirm: function () {
      // Message 'Yes' clicked, update show_tax_exempt_popup so we do not show popup again
      this.isThinking = true
      this.$store.dispatch('updateCustomerShowTaxExemptPopup', {
        show_tax_exempt_popup: 'n'
      })
        .then(() => {
          this.isThinking = false
          // We have to let this request finish before the redirect. Some browsers may not complete the request if we leave
          // Message 'Yes' clicked, take them to cert capture landing page
          window.location.href = '/cert-capture#add-certificate'
        })
    }
  }
}
</script>

<style scoped></style>
